<template>
  <v-navigation-drawer
    absolute
    style="position:sticky; height:auto !important; background:none !important;"
    floating
    right
    persistent
    permanent
    class="pb-3 case-menu-top"

  >
    <v-list id="case-edit-menu-items" dense class="pa-0 ma-0" v-if="caseEditMode">
      <div v-for="(fs1, i) in headers" :key="i">
        <v-list-tile
          id="case-edit-menu-item"
          @click="$vuetify.goTo(fieldsetId(fs1), goToOptions)"
          v-if="fs1"
        >{{fieldsetName(fs1)}}</v-list-tile>
        <v-divider></v-divider>
      </div>
    </v-list>

    <v-list id="case-edit-menu-items" dense class="pa-0 ma-0" v-if="caseNotesMode">
      <div v-for="(caseMenuItem, i) in caseMenuItems" :key="i">
        <v-list-tile
          id="case-edit-menu-item"
          @click="$vuetify.goTo('#' + caseMenuItem.id, goToOptions)"
          v-if="caseMenuItem"
        >{{fieldsetName(caseMenuItem)}}</v-list-tile>
        <v-divider></v-divider>
      </div>
    </v-list>

    <v-btn
      id="case-save-button"
      @click="buttonClick()"
      :disabled="saveButtonDisabled"
      color="success"
      class="mt-2"
      block
      v-if="caseEditMode"
    >{{ buttonText }}</v-btn>
  </v-navigation-drawer>
</template>

<script>
import inflection from "inflection"
import { mapState } from "vuex"

export default {
  name: "case-menu",
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    caseMenuItems: {
      type: Array,
      default: () => []
    },
    buttonText: {
      type: String,
      default: "Save Changes"
    },
    caseIsLoading: {
      type: Boolean,
      required: true
    },
    hasPermissionToSave: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    goToOptions: {
      duration: 500,
      offset: -14,
      easing: "easeInOutCubic"
    }
  }),
  computed: {
    ...mapState({
      currentUser: state => state.currentUser.me,
      currentFieldsets: state => state.cases.currentlySelected.case.schema.fieldsets,
      caseTypeCode: state =>
        state &&
        state.buckets &&
        state.buckets.current.caseType &&
        state.buckets.current.caseType.code
          ? state.buckets.current.caseType.code
          : undefined
    }),
    caseEditMode() {
      return this.headers && this.headers.length > 0
    },
    caseNotesMode() {
      return this.caseMenuItems && this.caseMenuItems.length > 0
    },
    saveButtonDisabled() {
      return this.caseIsLoading || !this.hasPermissionToSave
    }
  },
  methods: {    
    buttonClick() {
      this.$emit('save')
    },
    fieldsetName(fieldset) {
      if (!fieldset) return ""
      if (fieldset.display_name) {
        return fieldset.display_name
      } else if (fieldset.name) {
        return this.formatFieldset(fieldset.name)
      } else if (fieldset.subject !== undefined && fieldset.subject !== null) {
        return this.formatFieldset(fieldset.subject)
      } else {
        return this.formatFieldset(fieldset)
      }
    },
    fieldsetId(fieldset) {
      if (!fieldset) return ""
      if (fieldset.name) {
        return `#${fieldset.name}`
      } else {
        return `#${fieldset}`
      }
    },
    formatFieldset(label) {
      return inflection.humanize(label || "")
    }
  }
}
</script>

<style>
.case-menu-top {
  top: 116px !important;
  width:100% !important;
}

.with-summary .case-menu-top {
  top: 176px !important;
}
</style>
